import { useTranslation } from 'react-i18next';

import { Stack } from '@mui/material';

import clsx from 'clsx';

import Typography from '../../../../../components/Typography';
import { i18nNS } from '../../../../../i18n';
import BackgroundPlaceholder from '../../../../../icons/BackgroundPlaceholder';
import DeleteCrossIcon from '../../../../../icons/DeleteCrossIcon';
import {
  backgroundClasses,
  BackgroundImage,
  BackgroundImageControl,
  BackgroundImageControls,
  Root,
} from './styles';
import useBackground, { ALLOWED_FILE_EXTENSIONS } from './vm';

export interface BackgroundProps {
  className?: string;
}

const Background = ({ className }: BackgroundProps) => {
  const { t } = useTranslation([i18nNS.TIMER]);

  const { handleFileSelect, handleFileInputClick, handleRemoveFile, backgroundImage, isPresenting } =
    useBackground();

  return (
    <Root className={clsx(className, { [backgroundClasses.transparentBackground]: isPresenting })}>
      {!isPresenting && (
        <Stack justifyContent="center" alignItems="center">
          <label style={{ cursor: 'pointer' }}>
            <Stack alignItems="center" gap={2}>
              {/* Using Stack instead of Box for svg to take correct space */}
              <Stack p={3} color="grey.300">
                <BackgroundPlaceholder size={74} color="inherit" />
              </Stack>
              <Typography variant="paragraphMedium" color="primary">
                {t('add_background_image', { ns: i18nNS.TIMER })}
              </Typography>
              <input
                name="background-uploader"
                hidden
                type="file"
                accept={[
                  ...ALLOWED_FILE_EXTENSIONS.map((extension) => `image/${extension}`),
                  ...ALLOWED_FILE_EXTENSIONS.map((extension) => `.${extension}`),
                ].join(',')}
                onChange={handleFileSelect}
                onClick={handleFileInputClick}
              />
            </Stack>
          </label>
        </Stack>
      )}
      <div />
      {backgroundImage && (
        <div className={backgroundClasses.backgroundImageContainer}>
          <BackgroundImage src={backgroundImage} />
          {!isPresenting && (
            <BackgroundImageControls className={backgroundClasses.backgroundImageControls}>
              <label>
                <BackgroundImageControl iconOnly variant="text" color="primary" component="div">
                  <BackgroundPlaceholder size={24} />
                </BackgroundImageControl>
                <input
                  name="background-replacer"
                  hidden
                  type="file"
                  accept={[
                    ...ALLOWED_FILE_EXTENSIONS.map((extension) => `image/${extension}`),
                    ...ALLOWED_FILE_EXTENSIONS.map((extension) => `.${extension}`),
                  ].join(',')}
                  onChange={handleFileSelect}
                  onClick={handleFileInputClick}
                />
              </label>
              <BackgroundImageControl
                iconOnly
                variant="text"
                color="error"
                onClick={handleRemoveFile}
                className={backgroundClasses.removeBackgroundButton}
              >
                <DeleteCrossIcon size={16} />
              </BackgroundImageControl>
            </BackgroundImageControls>
          )}
        </div>
      )}
    </Root>
  );
};

export default Background;
